import type { IconProps } from './types';

function GridSingleIcon(props: IconProps) {
  const { size = 24, color = 'currentColor', ref, ...other } = props;

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      ref={ref}
      {...other}
    >
      <path d="M20.5 3.5V20.5H3.5V3.5H20.5Z" stroke={color} />
    </svg>
  );
}

export { GridSingleIcon };
